import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { BranchAvatarComponent } from './branch-avatar.component';

@NgModule({
  declarations: [
    BranchAvatarComponent
  ],
  imports: [
    CommonModule,
    MatIconModule,
    MatTooltipModule,
    RouterModule
  ],
  exports: [
    BranchAvatarComponent
  ]
})
export class BranchAvatarModule { }
